// extracted by mini-css-extract-plugin
module.exports = {"shapeContainer":"_3NEt6","badge":"XNibc","button":"_2I5Pg","conclusionField":"_2ilmy"};